module.exports = __webpack_public_path__ + "static/media/blogger-b.262699c4.svg";